import { AccountStore } from 'base/account_store';
import { Banner } from 'base/ui/banner';
import { Button } from 'base/ui/button';
import { Link } from 'base/ui/link';
import { TextSmallLight } from 'base/ui/typography';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getPricingParityOffer } from './pricing_parity_data';

export const PricingParityBanner = observer(function _PricingParityBanner({
  accountStore,
}: {
  accountStore: AccountStore;
}) {
  const offer = getPricingParityOffer(accountStore.member);
  if (!offer) return null;

  return (
    <Banner
      variant="white"
      icon={<span style={{ fontSize: '16px' }}>{offer.flag}</span>}
      actions={<Button href="/pricing" label="Upgrade" />}
    >
      <TextSmallLight>
        Looks like you’re from {offer.name}! Use the code{' '}
        <b>{offer.name.toUpperCase()}40</b> when signing up to get 40% off our{' '}
        <Link href="/pricing">Starter Plan</Link>.
      </TextSmallLight>
    </Banner>
  );
});
